import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Certificate } from '@app/_models/certificate';

@Component({
  selector: 'app-certificate-pagination',
  templateUrl: './certificate-pagination.component.html',
  styleUrls: ['./certificate-pagination.component.less']
})
export class CertificatePaginationComponent implements OnInit, OnChanges {
  @Input() certificates: Certificate[] = [];
  @Input() currentCertificateIndex = 0;
  @Input() totalCertificate = 0;
  
  @Output() previous = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() pageSelected = new EventEmitter<number>();
  
  // Controls how many page numbers to show on each side of current page
  private visiblePagesCount = 2;

  constructor() { }

  ngOnInit() {
    // Initialize component
  }
  
  ngOnChanges(changes: SimpleChanges) {
    // Check for changes to input properties
    if (changes.currentCertificateIndex || changes.totalCertificate) {
      // Handle changes if needed in the future
    }
  }
  
  /**
   * Get the visible certificate indices around the current one
   * For large certificate counts, we only show a few pages around the current one
   * @returns Array of indices to display in pagination
   */
  getVisibleCertificateIndices(): number[] {
    const indices: number[] = [];
    
    if (this.totalCertificate <= 7) {
      // If we have 7 or fewer certificates, show all of them
      for (let i = 0; i < this.totalCertificate; i++) {
        indices.push(i);
      }
    } else {
      // Otherwise, show a limited set around the current one
      const startIdx = Math.max(1, this.currentCertificateIndex - this.visiblePagesCount);
      const endIdx = Math.min(this.totalCertificate - 2, this.currentCertificateIndex + this.visiblePagesCount);
      
      for (let i = startIdx; i <= endIdx; i++) {
        indices.push(i);
      }
    }
    
    return indices;
  }
  
  /**
   * Navigate to the previous certificate
   */
  onPrevious() {
    if (this.currentCertificateIndex > 0) {
      this.previous.emit();
    }
  }
  
  /**
   * Navigate to the next certificate
   */
  onNext() {
    if (this.currentCertificateIndex < this.totalCertificate - 1) {
      this.next.emit();
    }
  }
  
  /**
   * Navigate to a specific certificate by index
   * @param index The index of the certificate to display
   */
  onPageSelected(index: number) {
    if (index !== this.currentCertificateIndex) {
      this.pageSelected.emit(index);
    }
  }
}
